import { PATH } from 'constants/path';

// Semantic step keys persisted via the existing saveStep / getStep endpoints
// (stepTypeEnum=KLARITY_ONBOARDING). Backend stores the raw string; only the
// frontend interprets these values.
export enum EInvitedProviderStep {
    CREATE_PROFILE_CREDENTIALS = 'INVITED_CREATE_PROFILE_CREDENTIALS',
    CREATE_PROFILE_GENDER = 'INVITED_CREATE_PROFILE_GENDER',
    SETUP_SERVICES_SPECIALTY = 'INVITED_SETUP_SERVICES_SPECIALTY',
    SETUP_SERVICES_PAYMENT = 'INVITED_SETUP_SERVICES_PAYMENT',
    SETUP_SERVICES_TEMPLATE = 'INVITED_SETUP_SERVICES_TEMPLATE',
    MARKETING_PERSONAL_ID = 'INVITED_MARKETING_PERSONAL_ID',
    MARKETING_MEDICAL_LICENSE = 'INVITED_MARKETING_MEDICAL_LICENSE',
    AVAILABILITY_WORKING_HOURS = 'INVITED_AVAILABILITY_WORKING_HOURS',
    AVAILABILITY_ADVANCE_NOTICE = 'INVITED_AVAILABILITY_ADVANCE_NOTICE',
    REVIEW = 'INVITED_REVIEW',
    GO_LIVE = 'INVITED_GO_LIVE',
    ADVANCE_SETTING = 'INVITED_ADVANCE_SETTING',
    COMPLETED = 'INVITED_COMPLETED',
}

// Maps each semantic step to the page route it belongs to. Used to resume an
// invited provider to the right page on re-entry.
export const INVITED_STEP_ROUTE: Record<EInvitedProviderStep, string> = {
    [EInvitedProviderStep.CREATE_PROFILE_CREDENTIALS]: PATH.INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE,
    [EInvitedProviderStep.CREATE_PROFILE_GENDER]: PATH.INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE,
    [EInvitedProviderStep.SETUP_SERVICES_SPECIALTY]: PATH.INVITED_PROVIDER_ONBOARDING_SERVICES,
    [EInvitedProviderStep.SETUP_SERVICES_PAYMENT]: PATH.INVITED_PROVIDER_ONBOARDING_SERVICES,
    [EInvitedProviderStep.SETUP_SERVICES_TEMPLATE]: PATH.INVITED_PROVIDER_ONBOARDING_SERVICES,
    [EInvitedProviderStep.MARKETING_PERSONAL_ID]: PATH.INVITED_PROVIDER_ONBOARDING_MARKETING_PROFILE,
    [EInvitedProviderStep.MARKETING_MEDICAL_LICENSE]: PATH.INVITED_PROVIDER_ONBOARDING_MARKETING_PROFILE,
    [EInvitedProviderStep.AVAILABILITY_WORKING_HOURS]: PATH.INVITED_PROVIDER_ONBOARDING_AVAILABILITY,
    [EInvitedProviderStep.AVAILABILITY_ADVANCE_NOTICE]: PATH.INVITED_PROVIDER_ONBOARDING_AVAILABILITY,
    [EInvitedProviderStep.REVIEW]: PATH.INVITED_PROVIDER_ONBOARDING_REVIEW,
    [EInvitedProviderStep.GO_LIVE]: PATH.INVITED_PROVIDER_GO_LIVE,
    [EInvitedProviderStep.ADVANCE_SETTING]: PATH.INVITED_PROVIDER_ADVANCED_SETTINGS,
    [EInvitedProviderStep.COMPLETED]: PATH.DASHBOARD,
};

export const isInvitedProviderStep = (value: unknown): value is EInvitedProviderStep =>
    typeof value === 'string' && Object.values(EInvitedProviderStep).includes(value as EInvitedProviderStep);
